/* eslint-disable hubspot-dev/prefer-hubspot-url-utils */
(function () {
  const allowedDomains = ['hubspot.com', 'hubspotqa.com', 'hubteam.com', 'hubteamqa.com'];
  const registeredIFrameAttributeKey = 'registered-embedded-academy-iframe';
  const unregisteredIFrameSelector = `iframe[src*='embedded-academy-ui']:not([${registeredIFrameAttributeKey}])`;
  const registerNewIFrames = () => {
    const iFrames = document.querySelectorAll(unregisteredIFrameSelector);
    iFrames.forEach(iFrame => {
      iFrame.setAttribute(registeredIFrameAttributeKey, 'true');
      const sendHandshake = () => {
        var _iFrame$contentWindow;
        (_iFrame$contentWindow = iFrame.contentWindow) === null || _iFrame$contentWindow === void 0 || _iFrame$contentWindow.postMessage({
          type: 'embeddedAcademy:syncHeight:ready',
          message: {
            ready: true
          }
        }, '*');
      };
      sendHandshake();
      iFrame.addEventListener('load', sendHandshake);
    });
  };
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (mutation.addedNodes.length) {
        const iframesAdded = [...mutation.addedNodes].some(node => {
          return node instanceof HTMLIFrameElement && node.src.includes('embedded-academy-ui');
        });
        if (iframesAdded) {
          registerNewIFrames();
        }
      }
    });
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  registerNewIFrames();
  window.addEventListener('message', message => {
    const allowedDomainsRE = new RegExp(`${allowedDomains.join('|')}$`);
    if (!allowedDomainsRE.test(message.origin)) return;
    if (!message.data.type.includes('embeddedAcademy:syncHeight')) return;
    const messageFrame = [...document.querySelectorAll("iframe[src*='embedded-academy-ui']")].find(iframe => {
      return iframe.contentWindow === message.source;
    });
    if (!messageFrame) return;
    if (!messageFrame.getAttribute(registeredIFrameAttributeKey)) {
      registerNewIFrames();
    }
    if (message.data.type !== 'embeddedAcademy:syncHeight:syncHeight') return;
    messageFrame.style.height = `${message.data.message.height}px`;
    messageFrame.style.overflow = 'hidden';
    // check if the iframe is in a div.hs-embed-wrapper which signals that it's embedded in a KB article
    const id = Math.random().toString(36).slice(-5);
    messageFrame.setAttribute('embedded-academy-random-id', id);
    if (document.querySelector(`div.hs-embed-wrapper iframe[embedded-academy-random-id="${id}"]`)) {
      messageFrame.style.position = 'relative';
      if (messageFrame.parentElement) {
        messageFrame.parentElement.style.padding = '0';
      }
    }
  });
})();